var React = require('react');

function SingleBlock1Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","stroke":"#1c1c1c","strokeWidth":"1.2","transform":"translate(-.8 -.807)"},[React.createElement("path",{"d":"m24.72 53.971-22.72-13.117v-26.235l22.72 13.117z","fill":"#fff","key":0}),React.createElement("g",{"fill":"#4e5eff","key":1},[React.createElement("path",{"d":"m47.443 14.62-22.722 13.116-22.721-13.117 22.722-13.119z","key":0}),React.createElement("path",{"d":"m47.443 40.854-22.722 13.118v-26.235l22.722-13.118z","key":1})])]));
}

SingleBlock1Inline.defaultProps = {"viewBox":"0 0 47.843 54.204"};

module.exports = SingleBlock1Inline;

SingleBlock1Inline.default = SingleBlock1Inline;
